export default {
  SET_ERROR: 'SET_ERROR',
  RESET_ERROR: 'RESET_ERROR',
  SET_INFO: 'SET_INFO',
  RESET_INFO: 'RESET_INFO',
  SET_SUCCESS_MESSAGE: 'SET_SUCCESS_MESSAGE',
  RESET_SUCCESS_MESSAGE: 'RESET_SUCCESS_MESSAGE',
  SELECT_PREFERRED_LANGUAGE: 'SELECT_PREFERRED_LANGUAGE',
  ON_CHANGE_USERNAME: 'ON_CHANGE_USERNAME',
  ON_CHANGE_GENDER: 'ON_CHANGE_GENDER',
  ON_CHANGE_MOBILE: 'ON_CHANGE_MOBILE',
  ON_CHANGE_OTP: 'ON_CHANGE_OTP',
  IS_API_PROGRESS: 'IS_API_PROGRESS',
  ON_CHANGE_AGE: 'ON_CHANGE_AGE',
  ON_SELECT_CITY: 'ON_SELECT_CITY',
  PROFILE_PATCH_RESPONSE: 'PROFILE_PATCH_RESPONSE',
  PROFILE_PATCH_ERROR: 'PROFILE_PATCH_ERROR',
  FETCHING_LOCATION: 'FETCHING_LOCATION',
  ON_SELECT_QUAL: 'ON_SELECT_QUAL',
  ON_SELECT_JOB_DURATION: 'ON_SELECT_JOB_DURATION',
  ON_SELECT_JOB_CATEGORY: 'ON_SELECT_JOB_CATEGORY',
  UPDATE_USER_DETAILS: 'UPDATE_USER_DETAILS',
  ON_SELECT_JOB_LOCALITIES: 'ON_SELECT_JOB_LOCALITIES',
  UPDATE_USER_EXP: 'UPDATE_USER_EXP',
  ON_SELECT_SKILLS: 'ON_SELECT_SKILLS',
  ON_SELECT_JOB_TYPE: 'ON_SELECT_JOB_TYPE',
  ON_SELECT_JOB_PREF: 'ON_SELECT_JOB_PREF',
  TOGGLE_EDIT_PROFILE: 'TOGGLE_EDIT_PROFILE',
  TOGGLE_WARNING: 'TOGGLE_WARNING',
  DELETE_ACCOUNT: 'DELETE_ACCOUNT',
  PENDING_DOCS: 'PENDING_DOCS',
  REMOVE_PENDING_DOC: 'REMOVE_PENDING_DOC',
  SET_JOB_CATEGORIES: 'SET_JOB_CATEGORIES',
  SET_JOB_REQUIREMENTS: 'SET_JOB_REQUIREMENTS',
  SALARY_SELECTED: 'SALARY_SELECTED',
  RESET_USER_ENTRY: 'RESET_USER_ENTRY',
  TOGGLE_LOGIN_OPTION: 'TOGGLE_LOGIN_OPTION',
  TOGGLE_FACEBOOK_LOGIN_LOADER: 'TOGGLE_FACEBOOK_LOGIN_LOADER',
  ON_ENTER_MOBILE: 'ON_ENTER_MOBILE',
  ON_ENTER_OTP: 'ON_ENTER_OTP',
};
